import { Form, Text } from "../../components";
import Localization from "../../localization";
import { useApi, useAuth } from "../../hooks";
import React, { useRef } from "react";
import { App } from "antd";

const fields = [
  {
    name: "alias",
    label: Localization.general.name,
    placeholder: Localization.general.firstLastName,
    rules: [
      {
        required: true,
        message: Localization.feedback.required_name_and_surname,
      },
    ],
  },
  {
    name: "email",
    type: "email",
    label: Localization.general.email_address,
    placeholder: Localization.placeholder.your_email,
    rules: [
      {
        type: "email",
        required: true,
        message: Localization.feedback.invalid_email,
      },
    ],
  },
  {
    type: "password",
    name: "password",
    rules: [
      {
        min: 4,
        required: true,
        message: Localization.feedback.invalid_password,
      },
    ],
    label: Localization.general.password,
    placeholder: Localization.general.type_password,
  },
  {
    type: "password",
    dependencies: ["password"],
    name: "confirm_password",
    label: Localization.general.confirm_password,
    placeholder: Localization.general.type_password,
    rules: [
      { required: true, message: "" },
      ({ getFieldValue }) => ({
        validator(_, value) {
          return getFieldValue("password") === value
            ? Promise.resolve()
            : Promise.reject(
                new Error(Localization.feedback.unmatched_password)
              );
        },
      }),
    ],
  },
  {
    face: "select",
    name: "countryCode",
    rules: [
      { required: true, message: Localization.feedback.required_country },
    ],
    label: Localization.general.region,
    placeholder: Localization.general.select_region,
    options: [
      { label: Localization.general.sweden, value: "se" },
      { label: Localization.general.united_kingdom, value: "uk" },
    ],
  },
];

const Register = ({ onLoginClick = () => {}, onRegister = async () => {} }) => {
  const formRef = useRef();
  const { register } = useAuth();
  const { message } = App.useApp();
  const { execute } = useApi();

  return (
    <div>
      <Form fields={fields} ref={formRef} />
      <Form.Submit
        type="primary"
        className="w-100 m-30-t"
        title={Localization.general.register}
        onClick={async () => {
          await execute(
            async () => {
              await formRef.current.validateFields();
              await register(formRef.current.getFieldsValue());
              await onRegister();
            },
            { success: "Welcome to safeland connect" }
          );
        }}
      />
      <Text color="secondary" className="text-align-center m-20-t">
        {Localization.register.footer + " "}
        <Text
          underline
          level="link"
          weight={"600"}
          onClick={onLoginClick}
          children={Localization.general.login}
        />
      </Text>
    </div>
  );
};

export default Register;
